import { Address } from "@/Common/Api/Contacts/Dto/Address";
import { PhoneNumber } from "@/Common/Api/Contacts/Dto/PhoneNumber";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import { CanadaState } from "@/Common/Resources/Lookups/Enums/CommonLookupCodes";
import { BaseBritishColumbiaObstetricalFileSubSection, BaseBritishColumbiaObstetricalFileSubSectionProps } from "@/Patient/Components/MedicalNote/Obstetric/Form/BritishColumbia/Subcomponent/BaseBritishColumbiaObstetricalFileSubSection";

class BritishColumbiaObstetricalPatientInformationSection extends BaseBritishColumbiaObstetricalFileSubSection<BaseBritishColumbiaObstetricalFileSubSectionProps, never> {
    public render(): JSX.Element {
        const preferredPhoneNumber = PhoneNumber.GetPrimaryPhoneNumber(this.props.patient?.Phones);
        const patient = this.props.patient;

        return (
            <div className="section border border-bottom">
                <div className="row row-form">
                    <div>
                        {this.renderRedirectField(
                            "PatientSurnameLabel",
                            patient.IndividualResponse.LastName?.substring(0, this.page2FieldLimits.PatientSurname.MaxChars) ?? "",
                            () => sessionStore.dispatch(LocalPatientOperations.Profile.PatientLastNameLabelClick),
                            "col-md-4"
                        )}
                        {this.renderRedirectField(
                            "PatientGivenNamesLabel",
                            patient.IndividualResponse.FirstName?.substring(0, this.page2FieldLimits.PatientGivenNames.MaxChars),
                            () => sessionStore.dispatch(LocalPatientOperations.Profile.PatientFirstNameLabelClick),
                            "col-md-8"
                        )}
                    </div>
                    <div className="col-md-12">
                        {this.renderRedirectField(
                            "lblAddress",
                            Address
                                .GetFullAddress(patient.Addresses.firstPreferredOrDefault(p => p.IsPreferred))
                                ?.substring(0, this.page2FieldLimits.PatientAddress.MaxChars),
                            () => sessionStore.dispatch(LocalPatientOperations.Profile.AddressLabelClick)
                        )}
                    </div>
                    <div>
                        {this.renderRedirectField(
                            "PhoneNumberAltLabel",
                            preferredPhoneNumber ? PhoneNumber.stringFormattedPhone(preferredPhoneNumber) : "",
                            () => sessionStore.dispatch(
                                LocalPatientOperations.Profile.PhoneLabelClick,
                                { contactPointId: preferredPhoneNumber?.ContactPoint_id }
                            ),
                            "col-md-4"
                        )}
                        {this.renderRedirectField(
                            "PersonalHealthNumberLabel",
                            patient.HealthCards
                                .firstOrDefault(p => p.ProvinceLookupId === cacheStore.GetLookupIdForProvince(CanadaState.BritishColumbia))
                                ?.Number
                                ?.substring(0, this.page2FieldLimits.PatientPersonalHealthNumber.MaxChars) ?? "",
                            () => sessionStore.dispatch(LocalPatientOperations.Profile.NAMLabelClick),
                            "col-md-8"
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export { BritishColumbiaObstetricalPatientInformationSection };
